// useExportsEnabled
//
// Per-project feature gate for the Exports subsystem. Reads
// `projects.exports_enabled` (boolean column added in
// 20260514000005_projects_exports_enabled_flag.sql).
//
// Returns `enabled` (boolean) and `loading`. While loading we return false
// so the UI stays hidden until the flag is confirmed — prevents a flash of
// the export controls on first render for projects that don't have it.

import { useEffect, useState } from "react";
import { supabase } from "@/shared/integrations/supabase/client";

export function useExportsEnabled(projectId: string | undefined | null) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId) {
      setEnabled(false);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      const { data, error } = await supabase
        .from("projects")
        .select("exports_enabled")
        .eq("id", projectId)
        .maybeSingle();
      if (cancelled) return;
      if (error) {
        console.warn("useExportsEnabled: query failed", error);
        setEnabled(false);
      } else {
        setEnabled(Boolean(data?.exports_enabled));
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return { enabled, loading };
}
